import { useEffect, useState } from 'react';
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import layoutConf from "../../config/layoutConf";
import MomSysMstMaterial from "./MomSysMstMaterial";
import MomSysMstMaterialFile from "./MomSysMstMaterialFile";

function MomSysMstMaterialInfo ( props ) {
    const [height, setHeight] = useState(0);
    const [selectMstGrid, setSelectMstGrid] = useState();

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const masterGridSetting = (data) => {
        setSelectMstGrid(data)
    } 

    return (
        <div style={{height: height}}>
            <ReflexContainer orientation="horizontal">
                <ReflexElement flex={0.5}>
                    <MomSysMstMaterial 
                        id="MomSysMstMaterial" 
                        masterGridSetting={masterGridSetting}
                    />
                </ReflexElement>

                <ReflexSplitter style={{height: layoutConf.reflex.splitterHeight}} />

                <ReflexElement>
                    {
                        (selectMstGrid)
                        ?
                        <MomSysMstMaterialFile 
                            id="MomSysMstMaterialFile" 
                            selectMstGrid={selectMstGrid}
                        />
                        :
                        <></>
                    }
                </ReflexElement>
            </ReflexContainer>
        </div>
    );
}

export default MomSysMstMaterialInfo;
